import React from "react";
import Header from "./Header";
import FriendlyMatchCards from "./FriendlyMatchCards";
import Footer from "./Footer";

export default function FriendlyMatch() {
  return (
    <>
      <Header link={"friendlyMatch"} />
      <FriendlyMatchCards />
      <Footer />
    </>
  );
}
